import React from "react";
import { Modal, Button } from "react-bootstrap";

interface PopUpPromotionProps {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
}

export default function PopUpPromotion({
  open,
  onClose,
  onAccept,
}: PopUpPromotionProps) {
  return (
    <Modal
      show={open}
      onHide={onClose}
      keyboard={false}
      style={{ border: "none" }}
      centered
      size="sm"
    >
      <Modal.Header
        style={{
          border: "none",
          textAlign: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #D96B8A 0%, #D65072 100%)",
          color: "#fff",
          borderRadius: "8px 8px 0 0",
        }}
      >
        <Modal.Title
          style={{
            border: "none",
            textAlign: "center",
            justifyContent: "center",
            fontWeight: 700,
            fontSize: "1.5rem",
          }}
        >
          🎉 ໂປຣໂມຊັນພິເສດ! 🎉
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "24px" }}>
        <div className="d-flex flex-column gap-3 items-center text-center">
          <div
            style={{
              background: "#FFF3E0",
              padding: "16px",
              borderRadius: "8px",
              border: "2px dashed #D96B8A",
            }}
          >
            <div style={{ fontSize: "1.1rem", fontWeight: 600, color: "#D65072" }}>
              ຊື້ 2 ບັດ ໃຊ້ 0 💎
            </div>
            <div style={{ fontSize: "0.9rem", marginTop: "8px", color: "#666" }}>
              ຟຣີ! ບໍ່ຕ້ອງເສຍເງິນເລີຍ
            </div>
          </div>
          
          <div style={{ fontSize: "0.95rem", color: "#333" }}>
            <div style={{ fontWeight: 600, color: "#D96B8A", marginBottom: "8px" }}>
              ໄລຍະເວລາໂປຣໂມຊັນ
            </div>
            <div>📅 14/01/2026 - 15/01/2026</div>
          </div>

          <div
            style={{
              background: "#E8F5E9",
              padding: "12px",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <div style={{ fontSize: "0.9rem", color: "#2E7D32" }}>
              ✨ ໂອກາດດີທີ່ບໍ່ຄວນພາດ!
            </div>
            <div style={{ fontSize: "0.85rem", color: "#666", marginTop: "4px" }}>
              ຊື້ສະຫລາກ 2 ໃບແລ້ວລຸ້ນລາງວັນໃຫຍ່ໄດ້ຟຣີ
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{ border: "none", justifyContent: "center", gap: 10 }}
      >
        <Button
          variant="secondary"
          onClick={onClose}
          className="flex-1 h-[45px]"
          style={{ background: "#ccc", border: "none" }}
        >
          ປິດ
        </Button>
        <Button
          variant="primary"
          onClick={onAccept}
          className="flex-1 h-[45px]"
          style={{ background: "#D96B8A", border: "none" }}
        >
          ເລືອກບັດເລີຍ
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
